import { Context } from '@nuxt/types'
import { IncomingMessage } from 'connect'
import { ILogger } from '@qest/logger-utils'
import * as SentryTypes from '@sentry/minimal'
import FrontendLogger from '~/module/logger/FrontendLogger'
import DevelopmentLogger from '~/module/logger/DevelopmentLogger'
import { ShopConfig } from '~/module/shopConfig/shopConfigPlugin'
import { AppConfig } from '~/config/appConfig.type'

export interface ILoggerContext extends Context {
  req: IncomingMessage & {
    logger: ILogger
  }
  logger: ILogger
  $sentry: typeof SentryTypes
  $shopConfig: ShopConfig
  $env?: AppConfig
}

export interface IInject {
  inject: (key: string, value: ILogger) => void
}

const strategies = {
  client(ctx: ILoggerContext, inject: IInject['inject']) {
    const { $sentry } = ctx

    const loggerEnvironmental = ctx.nuxtState.env.loggerEnvironmental
    const loggerEnvironmentalFront = `${loggerEnvironmental}-front`

    ctx.$sentry.setTag('environment', loggerEnvironmentalFront)

    if (!ctx.logger) {
      ctx.logger = new FrontendLogger(
        $sentry,
        ctx.nuxtState.shopConfig as ShopConfig
      )
      inject('logger', ctx.logger)
    }
  },

  server(ctx: ILoggerContext, inject: IInject['inject']) {
    if (!ctx.logger) {
      if (!ctx.req.logger) {
        // if in development server was not initialized and no logger came from req
        ctx.req.logger = new DevelopmentLogger()
      }
      ctx.logger = ctx.req.logger
      inject('logger', ctx.req.logger)
    }
  },
}

export default (ctx: ILoggerContext, inject: IInject['inject']) => {
  const key = process.client ? 'client' : 'server'
  const strategy = strategies[key]
  return strategy(ctx, inject)
}
